<template>
	<div :class="{ visible, absolute: Boolean(name), light: islightOverlay }" class="modal-overlay">
		<div class="modal-popup-wrap">
			<component :is="modal.name" :is-absolute="Boolean(name)" :options="modal.options" @close="close" />
		</div>
	</div>
</template>

<script>
import modalComponents from '~/components/modals'

const cleanModal = {
	name: '',
	options: {}
}

export default {
	name: 'Modal',
	components: modalComponents,
	props: {
		name: {
			type: String,
			required: false,
			default: ''
		}
	},
	data () {
		return {
			closing: false,
			visible: false,
			modal: cleanModal,
			islightOverlay: false
		}
	},
	created () {
		this.$modal.$on('modal-open', this.open)
		this.$modal.$on('modal-close', this.close)
	},
	methods: {
		async open (name = '', options = {}) {
			if (!options.notClosePreviousModal) {
				await this.close()
			}
			if (options && options.lightOverlay) {
				this.islightOverlay = true
			}
			if (options && options.component) {
				if (options.component === this.name) {
					this.visible = true
					this.modal = {
						name,
						options
					}
				}
			} else {
				this.visible = true
				this.modal = {
					name,
					options
				}
			}
		},
		close () {
			if (this.closing || !this.modal.name) {
				return
			}

			this.closing = true
			this.visible = false

			return new Promise((resolve) => {
				setTimeout(() => {
					this.modal = { ...cleanModal }
					this.closing = false
					resolve()
				}, 500)
			})
		}
	}
}
</script>
